import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-heading font-bold text-white mb-4">窝窝影院</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                窝窝影院提供免费在线观看、免费影视资源，免费高清视频，免费追剧，最新电影电视剧大全不缓冲，无广告全部免费，每日更新精彩内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">电影</Link>
                </li>
                <li>
                  <Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">电视剧</Link>
                </li>
                <li>
                  <Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">综艺</Link>
                </li>
                <li>
                  <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">动漫</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">热门推荐</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/article/6" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">狂飙</Link>
                </li>
                <li>
                  <Link to="/article/1" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">流浪地球3</Link>
                </li>
                <li>
                  <Link to="/article/7" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">三体</Link>
                </li>
                <li>
                  <Link to="/article/11" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">斗罗大陆</Link>
                </li>
                <li>
                  <Link to="/article/4" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">孤注一掷</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">品牌介绍</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">用户协议</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">隐私政策</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">免责声明</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 窝窝影院 wowocinema.com - 免费在线观看，免费影视，免费高清视频免费追剧
            </p>
            <p className="text-xs text-foreground-500">
              本站所有资源均来自互联网，仅供交流学习使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}